export default __webpack_public_path__ + "static/media/ph.05910967.svg";